import api from "apis/employeeRole";
import { WebApiRequest, HTTP_GET } from "tools/webservice";

export const getEmployeeRoles = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getRoles(),
  successCallback,
  mountedRef,
});
